module.exports = __webpack_public_path__ + "static/media/twitter.f4532ff2.svg";